import { render, staticRenderFns } from "./extrato.vue?vue&type=template&id=8c457b20&scoped=true"
import script from "./extrato.vue?vue&type=script&lang=js"
export * from "./extrato.vue?vue&type=script&lang=js"
import style0 from "./extrato.vue?vue&type=style&index=0&id=8c457b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c457b20",
  null
  
)

export default component.exports